"use strict";
/**
* Анимация процесса загрузки.
*
* @class WebAccess.components.notifications.Spinner
* @extends BaseObject
* @since 5.0.0.7300
*
* @example
* var spinner = new WA.CMP.notifications.Spinner()
* spinner.show();
*/
(function (global) {

  var Spinner = BaseObject.extend({
    // Спиннер.
    jSpinner: '',
    timer: '',

    init: function(jSpinner) {
      this.jSpinner = jSpinner || $('.loader');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Запуск анимации спиннера.
    * @method WebAccess.components.notifications.Spinner#_start
    * @private
    * @since 5.0.0.7300
    * @see http://easings.net/ru - Функции easing
    */
    _start: function () {
      var me = this;
      me.jSpinner.addClass('loader_animated');

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отложенный запуск анимации процесса загрузки.
    *
    * @method WebAccess.components.notifications.Spinner#showDelayed
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
    * @since 5.0.0.7300
    */
    showDelayed: function (opt_delay) {
      var me = this;
      opt_delay = opt_delay || 500;
      if (me.timer) clearTimeout(me.timer);
      me.timer = setTimeout(function () { me._start() }, opt_delay);
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отложенный запуск спиннера
    * @method WebAccess.components.notifications.Spinner#_stop
    * @return {WebAccess.components.notifications.Spinner}
    * @since 5.0.0.7300
    */
    _stop: function () {
      var me = this;
      me.jSpinner.removeClass('loader_animated');
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать анимацию процесса загрузки.
    *
    * @method WebAccess.components.notifications.Spinner#show
    * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
    * @since 5.0.0.7300
    */
    show: function () {
      if (this.jSpinner.length === 0) this.jSpinner = $('.loader');

      this._start();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать анимацию процесса загрузки в диалоговом окне.
    *
    * @method WebAccess.components.notifications.Spinner#showInDialog
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
    * @since 5.0.0.7300
    */
    showInDialog: function (opt_delay) {
      var dialog = $('.ui-dialog:visible, .wizard-form:visible');
      dialog.append('<div class="loader ui-dialog-loader" />');
      var dialogTopSpinner = $('.ui-dialog-loader');
      this.jSpinner = dialogTopSpinner;

      !!opt_delay ? this.showDelayed(opt_delay) : this.show();

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Скрыть анимацию процесса загрузки.
    *
    * @method WebAccess.components.notifications.Spinner#hide
    * @param {String} [opt_message] Cообщение о завершении процесса загрузки.
    * @param {Integer} [opt_delay] Задержка запуска анимации в миллисекундах
    * @param {Integer} [opt_callback] Функция, которая будет запущена после скрытия анимации.
    * @return {WebAccess.components.notifications.Spinner} Объект типа Spinner.
    * @since 5.0.0.7300
    */
    hide: function (opt_message, opt_delay, opt_callback) {
      if (this.timer) clearTimeout(this.timer);
      if (opt_message) {
        var toast = new WA.CMP.NTF.Toast();
        toast.show(opt_message, 'success', null, opt_delay);
      };
      if ($.isFunction(opt_callback)) {
        setTimeout(function () { opt_callback(); }, delay);
      }
      this._stop();
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.Spinner = Spinner;

})(window.WebAccess.components.notifications);
